<template>
	<div>
		<h1>Recruitment</h1>

		<i>
			Strategies for achieving adequate participant enrolment to reach target
			sample size
		</i>

		<InputSelectMulti
			question="Strategies implemented to achieve adequate participant enrolment were:"
			:options="recruitmentOptions"
			v-model="$tera.project.TrialWizard.recruitment"
			bookmark="participant-enrolment"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputRecruitment from "./OutputRecruitment.vue";

export default {
	data() {
		return {
			outputComponent: OutputRecruitment,
			recruitmentOptions: [
				{ label: "conducted an open trial" },
				{
					label:
						"gave telephone reminders to people who do not respond to a postal invitation"
				},
				{ label: "offered rewards for participation" }
			]
		};
	}
};
</script>
